<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.47803 20.7826C8.50684 12.3014 15.4056 5.44939 23.8867 5.47812C32.3679 5.50702 39.2199 12.4057 39.1912 20.8869V21.0608C39.0867 26.5739 36.0085 31.6695 32.2346 35.6521C30.0763 37.8934 27.666 39.8776 25.0519 41.5652C24.353 42.1698 23.3161 42.1698 22.6172 41.5652C18.7202 39.0287 15.2999 35.8262 12.5128 32.1043C10.0287 28.8587 8.61836 24.9194 8.47803 20.8347V20.7826Z"
      stroke="#359652"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      opacity="0.4"
      d="M23.8343 26C26.5525 26 28.7561 23.7964 28.7561 21.0782C28.7561 18.36 26.5525 16.1565 23.8343 16.1565C21.1161 16.1565 18.9126 18.36 18.9126 21.0782C18.9126 23.7964 21.1161 26 23.8343 26Z"
      stroke="#359652"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'LocationIcon',
  props: ['size'],
};
</script>

<style scoped>

</style>
